import React from "react";
import { Form,  Button, Private, Success, Fail, Spinner } from "./styles";


export const ContactForm = ({ handleSubmit, submitting, success, fail }) => (

        <Form name="contact-home" method="post" netlify-honeypot="bot-field" data-netlify="true" onSubmit={handleSubmit}>
            <input type="hidden" name="form-name" value="contact-home" />
            <label hidden> Nombre  </label>
            <input type="text" name="name" placeholder="Nombre" required/>
            <p className="hidden">
                <input type="text" name="bot-field" placeholder="Nombre" />
            </p>

            <label hidden>
            Email </label>
            <input type="email" name="email"  placeholder="Email" required/>
            <textarea  type="text" name="message" placeholder="Mensaje" required>
            </textarea>
            <Private>
                <label htmlFor="politica" > Acepto la <a href="/legal/politica-de-privacidad/" target="_blank" rel="nofollow noopener noreferrer">política de privacidad</a>  </label>
                <input type="checkbox" name="politica" id="politica" value="acepta-politica"  required/>
            </Private>

            <div className="center">
                { ! success  &&  ( <Button type="submit">Enviar { submitting && <Spinner />}</Button> )}
            </div>
            { fail && ( <Fail>
                    A ocurrido un <b>error</b>, puedes ponerte en contacto a través de: <a href="mailto:info@thecookies.agency"> info@thecookies.agency</a>
                </Fail>

            )}
            { success && ( <Success>
                Formulario enviado con éxito
            </Success> )}
        </Form>
);